import { memo, VFC, useState, useEffect, useCallback } from 'react';
import {
  Table,Thead,Tbody,Tr,Th,Td,
  Box,Flex,Center,Spinner,Divider,
  Text,UnorderedList,ListItem,
} from '@chakra-ui/react';
import { useIssue } from '../../hooks/useIssue';
import { ListButton } from '../atoms/button/ListButton';
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";
import { ErrorDialog } from '../../components/organisms/modal/ErrorDialog';
import { IssueTable } from "./IssueTable";
import { IssueDetailDialog } from '../organisms/modal/IssueDetailDialog';
import { issueObj, arObj, searchParam } from '../../types/issue';
import { useOpelog } from '../../hooks/useOpelog';
import { SearchInput } from '../atoms/input/SearchInput';

type Props = {
  setDTStr: (dt:string)=>void;
};

export const CurrentTable: VFC<Props> = memo((props) => {
  const { setDTStr } = props;
  const { currentData, executing, errObj, getCurrentData } = useIssue();
  const { loginUser } = useLoginUser();
  // const [ username ] = loginUser.username;
  // const [ userKind ] = loginUser.userKind;
  const [ arObjList, setARObjList ] = useState<Array<arObj>>([]);
  const [ arListNum, setARListNum ] = useState(0);
  const [ issueObjList, setIssueObjList ] = useState<Array<issueObj>>([]);
  const [ searchParam, setSearchParam ] = useState<searchParam>({
    username: '',
    userGroup: '',
    fromDate: '',
    toDate: '',
    buName: '',
    custName: '',
    blankFlag: false,
    cloud_type: '',
    noticeKind: '',
    eval_key: {},
  });
  const [ execFlag, setExecFlag ] = useState(false);
  const [ issueArn, setIssueArn ] = useState('');
  const { OutputOpelog } = useOpelog();
  const [ closeFlag, setCloseFlag ] = useState(false);

  // 初回１回実行制御
  useEffect(() => {
    setExecFlag(true);
  }, []);
  
  // API実行
  useEffect(() => {
    if( execFlag ){
      setExecFlag(false);
      getCurrentData(searchParam);
      OutputOpelog( 'issue_current', 'reference', '');
    }
  }, [getCurrentData,execFlag]);
  
  // 検索実行
  const execSearch = useCallback(() => {
    searchParam.eval_key = {};
    setIssueObjList([]);
    getCurrentData(searchParam);
    
  }, [searchParam]);
  
  useEffect(() => {
    if( currentData !== null ){
      setDTStr(`（${currentData.get_data_time} 現在）`);
      setARObjList(currentData.risk_abuse_list ?? "");
      setARListNum(currentData.risk_abuse_list.length);
      setIssueObjList(currentData.issue_now_list ?? "");
    }
  }, [execFlag,currentData,setDTStr]);

  return (
    <>
      {errObj && !closeFlag ? (
        <ErrorDialog errTitle='最新情報の取得エラー' errObj={errObj} opeErrMes="" setCloseFlag={setCloseFlag} />
        
      ) : (
        <>
        <SearchInput
          func='current'
          searchParam={searchParam}
          setSearchParam={setSearchParam}
          defaultSearchDays={loginUser.mypage_search_days}
          maxSearchDays={loginUser.max_group_search_days}
          cloud_list={loginUser.issue_cloud_list}
          executing={executing}
          execSearch={execSearch}
        />
        <Divider orientation="horizontal" mt="10px" />
        
        {executing ? (
          <Center h="20vh">
            <Spinner color="teal.500" />
          </Center>
        
        ) : closeFlag ? (
          <Center>
            <Box>
              <Text>検索条件を指定して絞り込みをお願いいたします。</Text>
            </Box>
          </Center>
        
        ) : (
          <>
          {arObjList.length !== 0 && (
            <>
            <Box id="ARList" margin="10px 10px 30px 10px">
              <Flex alignItems="flex-end">
                <Text fontSize="lg">
                  ■ABUSE & RISK一覧（{arListNum}件）
                </Text>
              </Flex>
              <Box margin="20px">
                <UnorderedList color="tomato" fontSize="sm">
                  <ListItem>こちらの一覧に掲載がある内容は、対象アカウントにて何らかの対処が必要です。<br />
                  クラウドやサポートからの通知内容などを参照いただき、必要な対処をおこなってください。</ListItem>
                </UnorderedList>
              </Box>
              <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
                <Thead background="#aaaaaa">
                  <Tr>
                  <Th color="white" fontSize="sm">No.</Th>
                  <Th color="white" fontSize="sm">お客様名</Th>
                  <Th color="white" fontSize="sm">クラウド種別</Th>
                  <Th color="white" fontSize="sm">アカウントID</Th>
                  <Th color="white" fontSize="sm">種別</Th>
                  <Th color="white" fontSize="sm">状況</Th>
                  <Th color="white" fontSize="sm">発生日時</Th>
                  <Th color="white" fontSize="md">対応期限<br />(または解消日時)</Th>
                  <Th color="white" fontSize="sm"></Th>
                </Tr>
                </Thead>
                <Tbody>
                  {arObjList.map((item:arObj,index:number) => (
                    <Tr key={index} verticalAlign="top">
                      <Td>{index+1}</Td>
                      <Td>{item.end_user}</Td>
                      <Td>{item.cloud_type}</Td>
                      <Td>{item.account_id}</Td>
                      <Td>{item.service_name}</Td>
                      <Td>{item.status}</Td>
                      <Td>{item.start_time}</Td>
                      <Td>{item.end_time}</Td>
                      <Td><ListButton onClick={()=>setIssueArn(item.health_arn)}>個別情報</ListButton></Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
            {issueArn !== '' && (
              <IssueDetailDialog issueArn={issueArn} setIssueArn={setIssueArn} />
            )}
            </>
          )}
            
          <IssueTable ptn='current' issueObjList={issueObjList} />
          </>
        )}
        </>
      )}
    </>
  );
});

